import { createFileRoute } from "@tanstack/react-router"
import { ManageCollectionDialog } from "~/components/collections/dialogs/ManageCollectionDialog"
import { Module, WorkspacePage } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import CollectionManagementList from "~/components/collections/CollectionManagementList"
import { useGetCollectionsWithDetails, useCollectionGroups } from "~/hooks/useCollections"
import { useGetAllBudgets } from "~/hooks/useBudgets"
import { usePageTracking } from "~/hooks/usePageTracking"
import { api } from "~/utils/api"
import { CollectionProvider } from "~/context/CollectionProvider"

export const Route = createFileRoute("/_auth/collection-management/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: collections, isLoading: collectionsLoading } = useGetCollectionsWithDetails()
  const { data: collectionGroups } = useCollectionGroups()
  const { data: budgets, isLoading: budgetsLoading } = useGetAllBudgets()
  const { data: demandPlanMap, isLoading: demandPlanLoading } =
    api.demandPlan.getCollectionDemandPlanMap.useQuery()
  usePageTracking("Collection Management")

  if (collectionsLoading || budgetsLoading || demandPlanLoading) return <LoadingOverlay />

  return (
    <CollectionProvider
      value={{ collections: collections ?? [], collectionGroups: collectionGroups ?? [] }}
    >
      <Module
        breadcrumb={<BreadcrumbWrapper />}
        actions={<ManageCollectionDialog stayOnPageAfterCreate />}
      >
        <WorkspacePage>
          <CollectionManagementList
            collections={collections ?? []}
            budgets={budgets ?? []}
            demandPlanMap={demandPlanMap ?? {}}
          />
        </WorkspacePage>
      </Module>
    </CollectionProvider>
  )
}
